import React from "react";
import { Alert } from "antd";
import { DEBUG } from "../../config";
import { TASKS } from "../../tasks";

const ComponentLoadingError = (props: { error: any }) => {
    if (DEBUG || (location.search || "").includes("debug")) {
        throw props.error;
    } else if (typeof Raven !== "undefined") {
        Raven.captureException(props.error);
    }

    return (
        <Alert
            message="We are sorry. An error occurred trying to load your task. We have been notified about the problem."
            type="error"
            showIcon
        />
    );
};

export const TaskComponents = Object.entries(TASKS).reduce(
    (acc: any, [key, loader]: [string, () => Promise<any>]) => {
        acc[key] = React.lazy(() => {
            return loader()
                .then(resolved => ({
                    default: resolved,
                }))
                .catch((error: any) => ({
                    default: () => <ComponentLoadingError error={error} />,
                }));
        });
        return acc;
    },
    {}
);
